module.exports = "/_next/static/images/EnergyStorageSolutions-ee961ce126cba8abd41e23d2f7e962a3.webp";